import React from "react";
import { DropdownMenu, DropdownMenuProps } from "@emisgroup/ui-dropdown-menu";

export declare type DropdownActionMenuItem = {
  /**
   * The function to call when this item is activated
   */
  action?: () => void;
  /**
   * Sets the item to a disabled state
   */
  disabled?: boolean;
  /**
   * The children to be rendered.
   */
  children?: React.ReactNode;
};

interface DropDownProps {
  /**
   * Class name of the element
   */
  className: string;
  /**
   * Id of the element
   */
  id?: string;
  /**
   * The items to display in the action menu - this is nested array,
   * allowing for groups of actions
   */
  data: DropdownActionMenuItem[];
  /**
   * The function to call when the menu is clicked away from
   */
  onClickAway?: () => void;
}

type DropdownProps = DropdownMenuProps & DropDownProps;

/**
 * Responsible for rendering the dropdown menu component
 * @returns dropdown menu elements
 */
export const UIDropdownMenu: React.FC<DropdownProps> = (props: DropdownMenuProps) => {

  return (
    <DropdownMenu
      { ...props}
    />
  );
};
